<template>
    <v-layout column>
        <v-layout align-center>
            <v-toolbar class="text-h5 mb-4">
                <v-icon class="mr-3">shopping_cart</v-icon>
                <v-flex>Reservation Options</v-flex>
            </v-toolbar>
        </v-layout>
        <v-form ref="form">
            <v-layout>
                <app-input
                    data-testid="convert-first-name-input"
                    class="convert-first-name-input px-2"
                    filled
                    label="First Name"
                    v-model="firstName"
                    :rules="'required'"
                ></app-input>
                <app-input
                    data-testid="convert-last-name-input"
                    class="convert-last-name-input px-2"
                    filled
                    label="Last Name"
                    v-model="lastName"
                    :rules="'required'"
                ></app-input>
            </v-layout>
            <v-layout>
                <app-input
                    data-testid="convert-email-input"
                    class="convert-email-input px-2"
                    filled
                    label="Email Address"
                    v-model="email"
                    type="email"
                    :rules="'required'"
                ></app-input>
                <app-input
                    data-testid="convert-phone-input"
                    class="convert-phone-input px-2"
                    filled
                    label="Phone Number"
                    v-model="phone"
                    type="phone"
                    :rules="'required'"
                ></app-input>
            </v-layout>
        </v-form>
        <v-layout justify-space-between>
            <v-flex xs6 class="pl-1 pr-2">
                <v-menu
                    data-testid="convert-move-in-menu"
                    class="convert-move-in-menu"
                    ref="moveIn"
                    v-model="moveInSelect"
                    :close-on-content-click="false"
                    :return-value.sync="moveInDate"
                    :nudge-right="10"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            data-testid="convert-move-in-date-input"
                            class="convert-move-in-date-input"
                            v-model="moveInDate"
                            label="Move-in Date"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        data-testid="convert-move-in-datepicker"
                        class="convert-move-in-datepicker"
                        v-model="moveInDate"
                        no-title
                        scrollable
                        :min="today"
                        :max="threeWeeks"
                        @change="$refs.moveIn.save(moveInDate)"
                    />
                </v-menu>
            </v-flex>
            <v-flex xs6 class="pl-1 pr-2">
                <v-menu
                    data-testid="convert-follow-up-menu"
                    class="convert-follow-up-menu"
                    ref="followUp"
                    v-model="followUpSelect"
                    :close-on-content-click="false"
                    :return-value.sync="followupDate"
                    :nudge-right="10"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            data-testid="convert-follow-up-date-input"
                            class="convert-follow-up-date-input"
                            :value="followupDate"
                            label="Follow-up Date"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        data-testid="convert-follow-up-datepicker"
                        class="convert-follow-up-datepicker"
                        v-model="followupDate"
                        no-title
                        scrollable
                        :min="today"
                        :max="threeWeeks"
                        @change="$refs.followUp.save(followupDate)"
                    />
                </v-menu>
            </v-flex>
        </v-layout>
    </v-layout>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";

export default {
  props: ["lead", "tenant"],

  data() {
    return {
      moveInSelect: null,
      followUpSelect: null
    };
  },

  computed: {
    ...mapState({
      info: state => state.tenant.info,
      options: state => state.tenant.options
    }),
    today() {
      let now = new Date();
      return new moment(now).format("YYYY-MM-DD");
    },
    threeWeeks() {
      let date = new Date();
      return new moment(date).add(21, "days").format("YYYY-MM-DD");
    },
    firstName: {
      get() {
        return this.$store.state.tenant.info.first_name;
      },
      set(newVal) {
        this.$store.commit("updateFirstName", newVal);
      }
    },
    lastName: {
      get() {
        return this.$store.state.tenant.info.last_name;
      },
      set(newVal) {
        this.$store.commit("updateLastName", newVal);
      }
    },
    phone: {
      get() {
        return this.$store.state.tenant.info.phone_number;
      },
      set(newVal) {
        this.$store.commit("updatePhone", newVal);
      }
    },
    email: {
      get() {
        return this.$store.state.tenant.info.email;
      },
      set(newVal) {
        this.$store.commit("updateEmail", newVal);
      }
    },
    reservationType: {
      get() {
        return this.$store.state.tenant.options.reservationType;
      },
      set(newVal) {
        this.$store.commit("updateReservationType", newVal);
      }
    },
    followupDate: {
      get() {
        return this.$store.state.tenant.options.followupDate;
      },
      set(newVal) {
        this.$store.commit("updateFollowupDate", newVal);
      }
    },
    moveInDate: {
      get() {
        return this.$store.state.tenant.options.moveInDate;
      },
      set(newVal) {
        this.$store.commit("updateMoveInDate", newVal);
      }
    },
    darkMode() {
      return this.$store.state.application.settings.darkTheme;
    }
  }
};
</script>
